module.exports = __webpack_public_path__ + "img/top_contact_bg.25c097c0.png";